import React from "react";
import Alert from "./index";
import useAlert from "../../../hooks/useAlert";

export default function AlertWrapper() {
  const { alert } = useAlert();
  return <Alert {...alert} />;
}
